<template>
  <div id="FaturasBoletos">
      <vuestic-widget id="conteudo_tabs" headerText="Autoescolas - Faturas e Boletos">
    <div class="row py-3 mb-3 d-flex">
      <div class="col-md-12">
        <div class="d-flex justify-content-center">
          <button type="button" class="btn btn-micro btn-dark" @click="downloadPlanilhaRetroativa()">
            <i id="clearButton" class="fa fa-file-excel-o pr-3 icon-branco"></i>
            <span class="font-button-modified">Gerar Faturamento anterior (13/10/2021)</span>
          </button>
        </div>
      </div>
    </div>
          <div class="row pt-3">

              <fieldset class="col-md-3">
                  <legend>Autoescola</legend>
        <model-select :options="selectCFC" v-model="selectedCFC" placeholder="Selecione um aluno"></model-select>
              </fieldset>

              <fieldset class="col-md-5" id="periodoConsultado">
                  <legend>Período a Ser Consultado</legend>
                  <div class="form-group p-0">
                      <div class="col m-0 p-0 pr-1 mr-2">
                          <input type="date" class="form-control pl-2 border rounded" v-model="dataInicio">
                      </div>
                      <div class="col m-0 p-0 pr-1 pl-2">
                          <input type="date" class="form-control pl-2 border rounded" v-model="dataFim">
                      </div>
          <!-- <div class="col m-0 p-0 pr-1 pl-2 d-inline">
            <vuestic-checkbox v-model="checkBoxBlock" @click="!checkBoxBlock" label='Por data de bloqueio' />
          </div> -->
                  </div>
              </fieldset>

              <fieldset class="col-md-2" id="tipoProcesso">
                  <legend>Processo</legend>
                  <select v-model="selectedProcesso" class="custom-select border">
                      <option v-for="item in selectProcesso" :value="item.value" :key="item.text">
                          {{ item.text }}
                      </option>
                  </select>
              </fieldset>

              <fieldset class="col-md-2" id="statusFatura">
                  <legend>Status</legend>
                  <select v-model="selectedStatusFatura" class="custom-select border">
                      <option v-for="item in selectStatusFatura" :value="item.value" :key="item.text">
                          {{ item.text }}
                      </option>
                  </select>
              </fieldset>

              <fieldset class="col-md-3" id="nomeAluno">
                  <legend style="display: flex">
                      <span>Nome do Aluno</span>
                      <div class="switch__container pl-3">
                          <input id="switch-shadow_aluno" v-model="toggleNomeAluno" class="switch switch--shadow" type="checkbox">
                          <label for="switch-shadow_aluno"></label>
                      </div>
                  </legend>
                  <div class="form-group">
                      <input type="text" class="form-control pt-0 pl-2 border rounded" id="nome_aluno" v-model="nomeAluno">
                  </div>
              </fieldset>

              <fieldset class="col-md-3" id="codigoBarra">
                  <legend style="display: flex">
                      <span>Código de Barras</span>
                      <div class="switch__container pl-3">
                          <input id="switch-shadow_codigo" v-model="toggleCodigoBarra" class="switch switch--shadow" type="checkbox">
                          <label for="switch-shadow_codigo"></label>
                      </div>
                  </legend>
                  <div class="form-group">
                      <input type="text" class="form-control pt-0 pl-2 border rounded" id="nome_aluno" v-model="codigoBarras">
                  </div>
              </fieldset>

              <div class="col-md-3 text-right">
                  <legend class="espacamento-oculto">.</legend>
                  <button class="btn btn-danger col-12 btn-micro mt-1" @click="clearInputs()">
                      <i id="clearButton" class="fa fa-file-excel-o pr-3 icon-branco"></i>
                      <span class="font-button-modified">Limpar</span>
                  </button>
              </div>

              <div class="col-md-3 text-right" v-if="loadTable">
                  <legend class="espacamento-oculto">.</legend>
                  <button class="btn btn-info col-12 btn-micro mt-1 disabled" aria-disabled="true" @click="loadingData()">
                      <i id="consultButton" class="fa fa-search pr-3 icon-branco"></i>
                      <span class="font-button-modified">Consultar</span>
                  </button>
              </div>

              <div class="col-md-3 text-right" v-else>
                  <legend class="espacamento-oculto">.</legend>
                  <button class="btn btn-info col-12 btn-micro mt-1" @click="loadData()">
                      <i id="consultButton" class="fa fa-search pr-3 icon-branco"></i>
                      <span class="font-button-modified">Consultar</span>
                  </button>
              </div>

              <div class="col-md-3 col-12" id="statusBoletos">
                  <legend class="pb-2">Status do Boleto</legend>
                  
                  <div class="status">
                      <div class="status-item">
                          <i class="fa fa-circle success"></i> PAGO
                      </div>
                      <div class="status-item">
                          <i class="fa fa-circle danger"></i>PENDENTE
                      </div>
                      <div class="status-item">
                          <i class="fa fa-circle secondary"></i> GRATUIDADE
                      </div>
                      <div class="status-item">
                          <i style="color: #f1c232;" class="fa fa-circle primary"></i> AGUARDANDO CONFIRMAÇÂO DE AULA
                      </div>
                  </div>
              </div>

              <fieldset class="col-md-2">
                  <legend>Pendente</legend>
                  <div class="form-group mt-0 pt-1 pl-2 border rounded disabled no-user-select">
                      <span>R$ {{ valorPendente }}</span>
                  </div>
              </fieldset>

              <fieldset class="col-md-2">
                  <legend>Pago</legend>
                  <div class="form-group mt-0 pt-1 pl-2 border rounded disabled no-user-select">
                      <span>R$ {{ valorPago }}</span>
                  </div>
              </fieldset>

              <fieldset class="col-md-2">
                  <legend>Gratuidade</legend>
                  <div class="form-group mt-0 pt-1 pl-2 border rounded disabled no-user-select">
                      <span>R$ {{ valorGratuidade }}</span>
                  </div>
              </fieldset>

              <div class="col-md-3" id="statusBoletos">
                  <legend>Ordenar por:</legend>
                  <select v-model="orderSearch" class="custom-select border">
                      <option v-for="item in ordernacaoSearch" :value="item.value" :key="item.text">
                          {{ item.text }}
                      </option>
                  </select>
              </div>

              <div class="col-md-2" id="faturasSelecionadas" v-if="faturasSelecionadas">
                  <legend>Faturas Selecionadas</legend>
                  <button class="btn btn-info col-10 btn-micro" @click="actionModalGerarBoleto()">
                      <i id="clearButton" class="fa fa-file-excel-o pr-3 icon-branco"></i>
                      <span class="font-button-modified">Gerar</span>
                  </button>
              </div>
              <!-- <div class="col-md-2" id="faturasSelecionadas" v-if="faturas.length > 0">
                  <legend>Adiar Bloqueio</legend>
                  <button class="btn btn-danger col-10 btn-micro" @click="$refs.showModalAdiarfaturas.open(), selectAllPayments = false">
                      <i id="clearButton" class="fa fa-file-excel-o pr-3 icon-branco"></i>
                      <span class="font-button-modified">Adiar</span>
                  </button>
              </div> -->

          </div>

          <div class="row mt-3">

              <div class="col-md-12 fatura-tabela">

                  <div v-if="loadTable" class="d-flex justify-content-center">
                      <component
                          :animation-duration="1000"
                          :is="'SpringSpinner'"
                          :color="'#4AE387'"
                          :size="80"
                          >
                      </component>
                  </div>
                  <table v-else-if="!loadTable && visible" class="table table-striped table-bordered table-responsive-sm text-center">
                      <thead>
                          <tr>
                              <th>
                                  <span v-if="faturas.length > 0">
                                      <input id="switch-shadow_checkAll" v-model="selectAll" @click="select" class="switch switch--shadow" type="checkbox">
                                      <label for="switch-shadow_checkAll"></label>
                                  </span>
                              </th>
                              <th>Status</th>
              <th>Cod Processo</th>
                              <th>Candidato</th>
                              <th>Código de Barras</th>
                              <th>CPF</th>
                              <th>Processo</th>
                              <th>Valor da Fatura</th>
                              <th>Valor do Desconto</th>
                              <th>Valor Original</th>
                              <th>Data de Vencimento</th>
                              <th>Ações</th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr v-if="faturas.length === 0">
                              <td colspan="8">Nenhum Registro Encontrado</td>
                          </tr>
                          <tr v-for="(fatura, index) in faturas" :key="fatura.index">
                              <td>
                <span v-if="fatura.link == null || fatura.link == ''">
                  <input :id="index" :value="fatura.id" v-model="selected" class="switch switch--shadow" type="checkbox">
                  <label :for="index"></label>
                </span>
                <span v-else>-</span>
                              </td>
                              <td>
                <span v-if="fatura.status === 'PAGO'"><i style="color: #20c997;" class="fa fa-circle success"></i></span>
                <span v-else-if="fatura.status == 'PENDENTE'"><i style="color: #dc3545;" class="fa fa-circle danger"></i></span>
                                  <span v-else-if="fatura.status == 'AGUARDANDO CONFIRMAÇÂO DE AULA'"><i style="color: #f1c232;" class="fa fa-circle primary"></i></span>
                <span v-else><i style="color: #ced4da;" class="fa fa-circle secondary"></i></span>
                              </td>
              <td>{{ fatura.codigo_processo }}</td>
                              <td>{{ fatura.nome }}</td>
                              <td>
                <a style="color: #4ab2e3; text-decoration: underline;" @click="abrirBoleto(fatura)" target="_blank" title="Visualizar Boleto">
                  <span v-if="fatura.linhaDigitavel !== null">
                    {{ fatura.linhaDigitavel }}
                  </span>
                  <span v-else>-</span>
                </a>
                              </td>
                              <td>{{ fatura.cpf }}</td>
                              <td>{{ fatura.tipo }}</td>
                              <td>{{ fatura.valor }}</td>
                              <td>{{ fatura.discountValue }}</td>
                              <td>{{ fatura.valorServico }}</td>
                              <td>{{ fatura.created_at.split('T')[0] }}</td>
                              <td>
                <!-- VISUALIZAR BOLETO -->
                <button class="mr-1 action-button" v-if="fatura.link !== null && fatura.link !== ''" title="Visualizar Borderô">
                  <a @click="getBordero(fatura)">
                    <i class="fa fa-file"></i>
                  </a>
                </button>

                                  <!-- ATUALIZAR BOLETO -->
                                  <button class="mr-1 action-button" v-if="(fatura.link !== null && fatura.link !== '') && fatura.pago !== true">
                                      <a @click="actionModalUpdate(fatura)">
                                          <i class="fa fa-refresh"></i>
                                      </a>
                                  </button>

                                  <!-- CANCELAR BOLETO -->
                                  <button v-if="(fatura.link !== null && fatura.link !== '') && fatura.pago !== true" class="action-button">
                                      <a @click="actionModalCancel(fatura)">
                                          <i class="fa fa-close"></i>
                                      </a>
                                  </button>

                                  <!-- DESCONTO -->
                                  <button v-if="fatura.link || fatura.status !== 'PENDENTE' || (fatura.discountValue === '0,00' || fatura.discountValue === null)" class="action-button" title="Dar desconto">
                                      <a @click="actionModalDiscount(fatura)">
                                          <i class="fa fa-percent"></i>
                                      </a>
                                  </button>
                              </td>
                          </tr>
                      </tbody>
                  </table>

              </div>
          </div>
          <!-- MODAL GERAR BOLETOS -->
    <div v-if="showModalGerarBoleto">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-container">

            <div class="modal-header">
              <slot name="header">
                <h3>Confirmar</h3>
              </slot>
            </div>

            <div class="modal-body">
              <slot name="body">
                <h4><b>Valor: </b>{{ valorBoleto.toFixed(2) }}</h4>
                Deseja realmente gerar esse boleto?
              </slot>
            </div>

            <div class="modal-footer">
              <slot name="footer">
                <button class="modal-default-button btn btn-danger btn-micro" @click="actionModalGerarBoleto()">
                  Não
                </button>
                <button class="modal-default-button btn btn-success btn-micro" :disabled="gerandoBoleto" @click="selectedGerarBoletos()">
                  Sim
                </button>
              </slot>
            </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
          <!-- MODAL CANCELAR -->
          <div v-if="showModalCancel">
              <transition name="modal">
                  <div class="modal-mask">
                      <div class="modal-wrapper">
                          <div class="modal-container">

                          <div class="modal-header">
                              <slot name="header">
                                  <h3>Confirmar</h3>
                              </slot>
                          </div>

                          <div class="modal-body">
                              <slot name="body">
                                  Deseja realmente cancelar esse boleto?
                              </slot>
                          </div>

                          <div class="modal-footer">
                              <slot name="footer">
                                  <button class="modal-default-button btn btn-danger btn-micro" @click="actionModalCancel()">
                                      Não
                                  </button>
                                  <button class="modal-default-button btn btn-success btn-micro" @click="selectedCancelarBoletos(idCancel)">
                                      Sim
                                  </button>
                              </slot>
                          </div>
                          </div>
                      </div>
                  </div>
              </transition>
          </div>
          <!-- MODAL ATUALIZAR -->
          <div v-if="showModalUpdate">
              <transition name="modal">
                  <div class="modal-mask">
                      <div class="modal-wrapper">
                          <div class="modal-container">

                          <div class="modal-header">
                              <slot name="header">
                                  <h3>Confirmar</h3>
                              </slot>
                          </div>

                          <div class="modal-body">
                              <slot name="body">
                                  Deseja realmente atualizar esse boleto?
                              </slot>
                          </div>

                          <div class="modal-footer">
                              <slot name="footer">
                                  <button class="modal-default-button btn btn-danger btn-micro" @click="actionModalUpdate()">
                                      Não
                                  </button>
                                  <button class="modal-default-button btn btn-success btn-micro" @click="selectedAtualizarBoletos(idUpdate)">
                                      Sim
                                  </button>
                              </slot>
                          </div>
                          </div>
                      </div>
                  </div>
              </transition>
          </div>
          <!-- MODAL DESCONTO -->
          <vuestic-modal ref="giveDiscountModal" id="modalDiscount" cancelClass="none" okClass="none">
            <div slot="title"> Desconto </div>

            <form id="form_agendamento" @submit.prevent="handleGiveDiscout">
                <div class="row mb-4" style="width: 40%;">
                    <label for="discountValue">Valor do desconto</label>
                    <currency-input id="discountValue" class="form-control border rounded pl-2 pr-2" v-model="discountValue" currency="BRL" locale="pt-BR" />
                </div>

                <div class="row">
                  <label slot="title" for="reason">Motivo do Desconto</label>
                  <div class="d-flex justify-content-center">
                    <textarea id="reason" v-model="justificativa" cols="70" rows="5" placeholder="Escreva o motivo pelo qual quer cancelar o agendamento." style="resize: none" class="border border-dark p-2" maxlength="200" required></textarea>
                  </div>
                </div>
                <div class="row justify-content-center mt-4">
                  <button type="submit" class="btn btn-primary" :disabled="discountButtonLoading">
                      <template v-if="!discountButtonLoading">Dar desconto</template>
                      <component
                          v-else
                          :animation-duration="1000"
                          :is="'SpringSpinner'"
                          :color="'#4AE387'"
                          :size="20"
                          >
                      </component>
                  </button>
                </div>
            </form>
          </vuestic-modal>
          <!-- MODAL ADIAR BLOQUEIO -->
          <!-- <vuestic-modal ref="showModalAdiarfaturas" :large="true" :cancelClass="'none'" :okClass="'none'">
              <div slot="title">Faturas</div>
              <div>
                  <p>Adicionar mais 3 dias a data de bloqueio <br>
                  <button class="btn btn-info btn-micro" @click="deferBlock()">
                      ADIAR
                  </button></p>
                  <table class="table table-responsive-sm">
                      <thead class="">
                          <tr>
                              <th>
                                  <input type="checkbox" id="todas" value="fatura.id" v-model="selectAllPayments">
                                  <label for="todas">TODOS</label>
                              </th>
                              <th><label for="todas">DATA BLOQUEIO</label></th>
                              <th><label for="todas">CANDIDATO</label></th>
                              <th><label for="todas">PROCESSO</label></th>
                              <th><label for="todas">VENCIMENTO</label></th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr v-for="fatura in faturas" :key="fatura.id">
                              <td><input type="checkbox" name="faturas" v-bind:id="fatura.id" v-bind:value="fatura.id"></td>
                              <td><label v-bind:for="fatura.id">{{ fatura.bloqueio }}</label></td>
                              <td><label v-bind:for="fatura.id">{{ fatura.nome }}</label></td>
                              <td><label v-bind:for="fatura.id">{{ fatura.tipo }}</label></td>
                              <td><label v-bind:for="fatura.id">{{ fatura.created_at }}</label></td>
                          </tr>
                      </tbody>
                  </table>
              </div>
              <hr>
              <button class="btn btn-info btn-micro" @click="deferBlock()">
                  ADIAR
              </button>
          </vuestic-modal> -->
          <a href="#" hidden id="downloadPDF"></a>
    <iframe id="planilha" src="" hidden></iframe>

      </vuestic-widget>
  </div>
</template>

<script>
import urlApiV1 from '../../../router/urlApi'
import urlApi from '../../../router/urlApiV2'
import * as spinners from 'epic-spinners'
import IndexController from '../../faturas/IndexController'
import { ModelSelect } from 'vue-search-select'
import { CurrencyInput } from 'vue-currency-input'

export default {
  name: 'FaturasBoletos',
  components: {
      urlApi,
      ...spinners,
      ModelSelect,
      CurrencyInput,
  },

  data () {
      return {
          loadTable: false,
          toggleCodigoBarra: false,
          toggleNomeAluno: false,
          faturasSelecionadas: false,
          todosBoletos: false,
          show: false,
          dataInicio: '',
          dataFim: '',
          todoPeriodo: '',
          valorPendente: '0,00',
          valorPago: '0,00',
          valorGratuidade: '0,00',
          nomeAluno: '',
          codigoBarras: '',
          faturas: [],
          paymentSelected: [],
          paymentToDeferBlock:  [],
          selectAllPayments: false,
          selectedCFC: '',
          selectCFC: [
              { value: '', text: 'Selecione Uma Autoescola'},
          ],
          selectedProcesso: '',
          selectProcesso: [
      { value: '', text: 'SELECIONE O PROCESSO'},
      { value: '1', text: 'TEÓRICO'},
      { value: '2', text: 'PRÁTICO'},
      { value: '3', text: 'INCLUSÃO'},
      { value: '4', text: 'RECICLAGEM'},
      { value: '5', text: 'RENOVAÇÃO'},
          ],
          selectedStatusFatura: '',
          selectStatusFatura: [
      { value: '', text: 'SELECIONE O STATUS'},
      { value: '2', text: 'PAGO'},
      { value: '1', text: 'PENDENTE'},
      { value: '4', text: 'GRATUIDADE'},
              { value: '3', text: 'CANCELADO'},
              { value: '7', text: 'AGUARDANDO CONFIRMACAO DE AULA'},
          ],
          orderSearch: '',
          ordernacaoSearch: [
              { value: '', text: 'SELECIONE A ORDENAÇÃO'},
              { value: 'nome', text: 'NOME'},
              { value: 'codigoBarras', text: 'CÓDIGO DE BARRAS'},
              { value: 'cpf', text: 'CPF'},
              { value: 'tipo', text: 'TIPO'},
              { value: 'vencimento', text: 'VENCIMENTO'},
          ],
          selected: [],
          selectAll: false,
    showModalGerarBoleto: false,
          showModalCancel: false,
          showModalUpdate: false,
          showModalAdiarFaturas: false,
          gerandoBoleto: false,
          discountedFatura: {
              id: '',
              schema: '',
          },
          justificativa: '',
          discountValue: null,
          discountButtonLoading: false,
          consultQuery: '',
          // checkBoxBlock: false
          visible: false,
      }
  },

  mounted() {

      this.loadCfc();

  },

  methods: {
      abrirBoleto(fatura) {
          this.loadTable = true;
          let anchor = document.createElement("a");
          document.body.appendChild(anchor);
          this.$http.get(urlApi + '/boleto/show/' + this.selectedCFC + '/' + fatura.link, {responseType: 'blob'})
          .then(response => response.blob())
          .then(responseBlob => {
              let objectUrl = window.URL.createObjectURL(responseBlob);
              anchor.href = objectUrl;
              anchor.download = 'boleto.pdf';
              anchor.click();
              window.URL.revokeObjectURL(objectUrl);
              this.btn_load = false;
              document.body.removeChild(anchor);
              this.loadTable = false;
          });
      },
      select()
      {
    this.selected = [];
    if (!this.selectAll) {
              for (let i in this.faturas) {
                  if(this.faturas[i].link == null)
                  {
                      this.selected.push(this.faturas[i].id);
                  }
              }
    }
  },
      clearInputs()
      {
          this.loadTable = ''
          this.toggleCodigoBarra = false
          this.toggleNomeAluno = false
          this.dataInicio = ''
          this.dataFim = ''
          this.todoPeriodo = ''
          this.valorPendente = '0,00'
          this.valorPago = '0,00'
          this.valorGratuidade = '0,00'
          this.nomeAluno = ''
          this.codigoBarras = ''
          this.selectedProcesso = ''
          this.selectedStatusFatura = ''
          this.selectedCFC = ''
          this.todosBoletos = false
          this.faturas = ''
          this.visible = false
          // this.checkBoxBlock = false
      },
      loadCfc()
      {
          this.$http.get(urlApi + '/autoescola/todas').then(response => {
              response.data.dados.map(autoescolas =>{
                  if(autoescolas.nome_fantasia !== 'TEwSTE')
                  {
                      let sindicato = autoescolas.sindicato ? 'SINDICATO' : '';
                      this.selectCFC.push({
                          value: autoescolas.tenant_schema,
                          text: autoescolas.nome_fantasia+' | '+ sindicato,
                      })
                  }
              })
          }).catch(function (error) {
              // alert('erro: '+error)
              this.$toasted.show('Erro!'+ error, {
                  position: 'top-right',
              });
          })
      },
      loadingData()
      {
          this.$toasted.show('Aguarde a última consulta ser concluída!', {
              position: 'top-right',
          });
      },
      loadData()
      {
          this.selected = [];
          if(this.selectedCFC === '')
          {
              this.$toasted.show('Selecione uma autoescola!', {
                  position: 'top-right',
              });

              this.loadTable = false;
              return;
          }

          if (this.toggleCodigoBarra === false && this.toggleNomeAluno === false && (!this.dataInicio || !this.dataFim)) {
              this.$toasted.show('Selecione todas as datas!', {
                  position: 'top-right',
              });

              this.loadTable = false;
              return;
          }

          if (this.dataInicio || this.dataFim) {
              const dataIni = new Date(this.dataInicio)
              const dataFim = new Date(this.dataFim)
  
              if (dataIni > dataFim) {
                  this.$toasted.show('A data incial deve ser menor que a data final', {
                      position: 'top-right',
                  });
  
                  this.loadTable = false;
                  return;
              }
          }

          this.loadTable = true;
          // RETORNO DE DADOS DO BACK
          this.searchFor();
      },
      searchFor()
      {
          if(this.toggleCodigoBarra === true)
          {
              // console.log('codigo barra')
              // CONSULTA POR CÓDIGO DE BARRAS
      var data = { schema: this.selectedCFC, codigoBarras: this.codigoBarras, ordenar: this.orderSearch };
      data = `?schema=${data.schema}&codigoBarras=${data.codigoBarras}&ordenar=${data.ordenar}`;
          } else if (this.toggleNomeAluno === true)
          {
              // console.log('nome')
              // CONSULTA POR NOME DO ALUNO
              var data = {
                  schema: this.selectedCFC,
                  nome: this.nomeAluno,
                  ordenar: this.orderSearch
              };
      data = `?schema=${data.schema}&nome=${data.nome}&ordenar=${data.ordenar}`;
          } else
          {
              // console.log('nenhum')
              var data = {
                  schema: this.selectedCFC,
                  periodo: [this.dataInicio, this.dataFim],
                  tipo: this.selectedProcesso,
                  status: this.selectedStatusFatura,
                  ordenar: this.orderSearch
                  // periodoBloqueio: this.checkBoxBlock
              };
      data = `?schema=${data.schema}&periodo[]=${data.periodo[0]}&periodo[]=${data.periodo[1]}&tipo=${data.tipo}&status=${data.status}&ordenar=${data.ordenar}`;
          }
          this.resultConsult(data)
      },
      resultConsult(data)
      {
          this.loadTable = true
          const consult = `${urlApi}/faturamento/consulta${data}`
          this.consultQuery = data
          this.$http.get(consult).then(response => {
              if(response.body.dados > '')
              {
                  this.todosBoletos = true;
              }
              else
              {
                  this.todosBoletos = false;
              }
              this.selectAll = false;
              this.valorPendente = response.body.pendente
              this.valorPago = response.body.pago
              this.valorGratuidade = response.body.gratuidade
              this.faturas = response.body.dados
              this.loadTable = false;
              this.visible = true

          }).catch(function (error) {
              this.$toasted.show(error.body.mensagem, {
                  position: 'top-right',
              });
              this.loadTable = false;
              this.faturas = ''
          })
      },
      toggleChecked(novo, antigo)
      {
          console.log('novo' + novo + 'antigo' + antigo)
          if(novo == true) {
              this.dataInicio = '';
              this.dataFim = '';
              this.selectedProcesso = '',
              this.selectedStatusFatura = '',
              document.getElementById("periodoConsultado").disabled = true;
              document.getElementById("tipoProcesso").disabled = true;
              document.getElementById("statusFatura").disabled = true;
          }else
          {
              document.getElementById("periodoConsultado").disabled = false;
              document.getElementById("tipoProcesso").disabled = false;
              document.getElementById("statusFatura").disabled = false;
          }
      },
  actionModalGerarBoleto()
  {
    if(this.showModalGerarBoleto === true)
          {
              this.showModalGerarBoleto = false;
          }else
          {
              this.valorTotal();
              this.showModalGerarBoleto = true;
          }
  },
      actionModalAdiarBloqueio()
      {
    if(this.showModalAdiarFaturas === true)
          {
              this.showModalAdiarFaturas = false;
          }else
          {
              this.getfaturasSelecionadas();
              this.showModalAdiarFaturas = true;
          }
      },
      selectedGerarBoletos()
      {
          var data = {
              schema: this.selectedCFC,
              id: this.selected,
          };
          this.gerandoBoleto = true;
          // console.log(data);
          this.$http.post(urlApi + '/boleto/criar', data).then(response => {
              // console.log(response);

              this.$toasted.show(response.body.mensagem, {
                  position: 'top-right',
              });
              var url = response.body.linkBoleto;
              if(url.startsWith('http')){
                  window.open(url);
              }else {
                  window.open(window.location.origin + '/' + url);
              }
      this.actionModalGerarBoleto();
              this.gerandoBoleto = false;
              this.loadData();

          }).catch(function (error) {
              this.$toasted.show(error.body.mensagem, {
                  position: 'top-right',
              });
              this.gerandoBoleto = false;
          });
      },
      selectedCancelarBoletos(idCancel)
      {
          var data = {
              schema: this.selectedCFC,
              id: idCancel,
          };
          // console.log(data)
          this.$http.post(urlApi + '/boleto/cancelar', data).then(response => {
              // Fechar Modal
              this.showModalCancel = false;
              // console.log(response);
              this.$toasted.show(response.body.mensagem, {
                  position: 'top-right',
              });
              this.loadData();

          }).catch(function (error) {
              this.$toasted.show(error.body.mensagem, {
                  position: 'top-right',
              });
              // Fechar Modal
              this.showModalCancel = false;
          });
      },
      selectedAtualizarBoletos(idUpdate)
      {
          if(idUpdate !== null)
          {
              var data = {
                  schema: this.selectedCFC,
                  id: idUpdate,
              };
          }
          else
          {
              var data = {
                  schema: this.selectedCFC,
                  id: this.selected,
              };
          }
          // console.log(data);
          this.$http.post(urlApi + '/boleto/atualizar', data).then(response => {
              // Fechar Modal
              this.showModalUpdate = false;
              // DOWNLOAD PDF
              let code64 = response.body.dataPDF;

      var pdf = 'data:application/octet-stream;base64,' + code64;

      var dlnk = document.getElementById('downloadPDF');
      dlnk.download="novoCFC.pdf"
      dlnk.href = pdf;
      dlnk.click();
              // ABRIR BOLETO
              var url = response.body.linkBoleto;
              window.open(url);
              // console.log(response);
              this.$toasted.show(response.body.mensagem, {
                  position: 'top-right',
              });

              this.loadData();

          }).catch(function (error) {
              this.$toasted.show(error.body.mensagem, {
                  position: 'top-right',
              });
              // Fechar Modal
              this.showModal = false;
          });
      },
      actionModalCancel(fatura)
      {
          if(this.showModalCancel === true) {
              this.showModalCancel = false;
          } else {
              this.showModalCancel = true;
              this.idCancel = fatura.id;
              console.log(this.idCancel)
          }
      },
      actionModalDiscount(fatura)
      {
          console.log(fatura)
          this.$refs.giveDiscountModal.open()

          this.discountedFatura = {
              id: fatura.id,
              schema: this.selectedCFC,
          }
      },
      handleGiveDiscout () {
          this.discountButtonLoading = true

          if (!this.discountValue) {
              this.$toasted.show('Insira um valor valido para o desconto.', {
                  position: 'top-right',
              })

              this.discountButtonLoading = false

              return
          }

          this.$http.post(`${urlApi}/faturamento/desconto`, {
              faturaId: this.discountedFatura.id,
              faturaSchema: this.discountedFatura.schema,
              discountValue: this.discountValue,
              reason: this.justificativa,
          }).then(response => {
              this.$toasted.show(response.body.mensagem, {
              
              })
              this.resultConsult(this.consultQuery)
              this.discountButtonLoading = false
              this.$refs.giveDiscountModal.close()
              this.$refs.largeModal.close()
              this.discountedFatura = {
                  id: '',
                  schema: ''
              }
          }).catch(err => {
              this.$toasted.show(err.body.mensagem, {
                  position: 'top-right',
              })

              this.discountButtonLoading = false
          })
      },
      actionModalUpdate(fatura)
      {
          if(this.showModalUpdate === true) {
              this.showModalUpdate = false;
          } else {
              this.showModalUpdate = true;
              this.idUpdate = fatura.id;
              console.log(this.idUpdate)
          }
      },
      getBordero(fatura)
  {
    var data = { schema: this.selectedCFC, id: fatura.id, };

    IndexController.getBordero(data,
      (response) => {
        // TRATAMENTO AO OBTER A RESPOSTA
        if(response.data.sucesso === true)
        {
          // DOWNLOAD PDF
          var dlnk = document.getElementById('downloadPDF');
          dlnk.download="relacao de alunos.pdf"
          dlnk.href = 'data:application/octet-stream;base64,' + response.data.dataPDF;
          dlnk.click();
        }

        // TRATAMENTO AO OBTER ERRO
        if(response.data.sucesso === false)
        {

        }
      }
    );
  },
  valorTotal()
  {
    this.valorBoleto = 0;
    this.selected.forEach(
      (faturaSelecionada) => {
        this.faturas.map((faturas) => {
          if(faturas.id == faturaSelecionada)
          {
            this.valorBoleto += parseFloat(faturas.valor.replace(/,/, '.'))
          }
        })
      }
    );
  },
      getfaturasSelecionadas()
      {
          this.paymentSelected = [];
          this.selected.forEach(
      (faturaSelecionada) => {
        this.faturas.map((faturas) => {
          if(faturas.id == faturaSelecionada)
          {
            this.paymentSelected.push(faturas);
          }
        })
      }
    );
      },
      // deferBlock()
      // {
      //     this.paymentToDeferBlock = [];
      //     let checkboxs = document.getElementsByName("faturas");
      //     for(var i=0; i < checkboxs.length; i++)
      //     {
      //         if(checkboxs[i].checked)
      //         {
      //             this.paymentToDeferBlock.push(checkboxs[i].value);
      //         }
      //     }
      //     if(this.paymentToDeferBlock.length > 0)
      //     {
      //         var data = { schema: this.selectedCFC, ids: this.paymentToDeferBlock, };
      //         IndexController.deferBlock(data,
      //             (response) => {
      //                 if(response.status == 200)
      //                 {
      //                     let bloqueioAulas = []
      //                     for(const adiamento of response.body) {
      //                         if(adiamento.bloqueado)
      //                         {
      //                             let alunoBloqueado = this.faturas.find((element) => element.id == adiamento.id)
      //                             bloqueioAulas.push({ nome: alunoBloqueado.nome, razao: adiamento.mensagem })
      //                         }
      //                     }
      //                     console.log(bloqueioAulas)
      //                     if(bloqueioAulas.length > 0) {
      //                         let msg = "Alunos ainda bloqueados:\n"
      //                         for (const aluno of bloqueioAulas) {
      //                             msg = msg.concat(aluno.nome + ' - ' + aluno.razao + "\n")
      //                         }
      //                         alert(msg)
      //                         console.log(msg)
      //                     }
      //                     this.loadData()
      //                     this.$refs.showModalAdiarfaturas.close()
      //                 }
      //             }
      //         );
      //     }else
      //     {
      //         this.$toasted.show('Nenhuma fatura selecionada!', {
      //             position: 'top-right',
      //         });
      //     }
      // },

  downloadPlanilhaRetroativa()
  {
          if(this.selectedCFC == '')
          {
              this.$toasted.show('Necessário selecionar uma autoescola!', {
                  position: 'top-right',
              });
              return;
          }
    var data = { schema: this.selectedCFC };
    var iframe = document.getElementById('planilha');
    iframe.src = urlApiV1 + '/faturamento/planilha?autoescola=' + data.schema
  }
  },

  watch: {
      selectAllPayments(novo)
      {
          if(novo === true)
          {
              let checkboxs = document.getElementsByName("faturas");
              console.log(checkboxs);
              for(var i=0; i < checkboxs.length; i++)
              {
                  checkboxs[i].checked = true;
              }
          }else
          {
              let checkboxs = document.getElementsByName("faturas");
              for(var i=0; i < checkboxs.length; i++)
              {
                  checkboxs[i].checked = false;
              }
          }
      },
      dataInicio(nova, antiga)
      {
          if(nova != '' && this.dataFim != ''){
              if(new Date(nova) > new Date(this.dataFim)){
                  this.$toasted.show('Data Inicia Deve Ser Menor do Que Data Final', {
                      position: 'top-right',
                  });
                  this.dataInicio = '';
              }else{
                  // document.getElementById("fieldConsulta").disabled = false;
              }
          }else{
              // document.getElementById("fieldConsulta").disabled = true;
          }
      },
      dataFim(nova, antiga)
      {
          if(nova != '' && this.dataInicio != ''){
              if(new Date(nova) < new Date(this.dataInicio)){
                  this.$toasted.show('Data Final Deve Ser Maior do Que Data Inicial', {
                      position: 'top-right',
                  });
                  this.dataFim = '';
              }else{
                  // document.getElementById("fieldConsulta").disabled = false;
              }
          }else{
              // document.getElementById("fieldConsulta").disabled = true;
          }
      },
      toggleCodigoBarra(novo, antigo)
      {
          // console.log('codigo' + novo);
          // FUNCAO
          if(novo == true)
          {
              this.$toasted.show('Consulta Pelo Código de Barras', {
                  position: 'top-right',
              });
              if(this.toggleNomeAluno == true)
              {
                  this.toggleNomeAluno = false;
              }
              else if(this.toggleCodigoBarra == true || this.toggleNomeAluno == true)
              {
                  document.getElementById("periodoConsultado").disabled = true;
                  document.getElementById("tipoProcesso").disabled = true;
                  document.getElementById("statusFatura").disabled = true;
              }
              else
              {
                  this.$toasted.show('Erro!', {
                      position: 'top-right',
                  });
              }
          }
          else if(this.toggleNomeAluno == false && this.toggleCodigoBarra == false)
          {
              document.getElementById("periodoConsultado").disabled = false;
              document.getElementById("tipoProcesso").disabled = false;
              document.getElementById("statusFatura").disabled = false;
          }
          else
          {
              document.getElementById("periodoConsultado").disabled = true;
              document.getElementById("tipoProcesso").disabled = true;
              document.getElementById("statusFatura").disabled = true;
          }
      },
      codigoBarras(novo, antigo)
      {
          if(novo.length  > 0)
          {
              this.toggleCodigoBarra = true;
              this.toggleNomeAluno = false;
              this.nomeAluno = ''
          }else
          {
              this.toggleCodigoBarra = false;
          }
      },
      toggleNomeAluno(novo, antigo)
      {
          // console.log('nome' + novo);
          // FUNCAO
          if(novo == true)
          {
              this.$toasted.show('Consulta Pelo Nome do Aluno', {
                  position: 'top-right',
              });
              if(this.toggleCodigoBarra == true) {
                  this.toggleCodigoBarra = false;
              }
              else if(this.toggleCodigoBarra == true || this.toggleNomeAluno == true)
              {
                  document.getElementById("periodoConsultado").disabled = true;
                  document.getElementById("tipoProcesso").disabled = true;
                  document.getElementById("statusFatura").disabled = true;
              }
              else
              {
                  this.$toasted.show('Erro!', {
                      position: 'top-right',
                  });
              }
          } else if(this.toggleNomeAluno == false && this.toggleCodigoBarra == false)
          {
              document.getElementById("periodoConsultado").disabled = false;
              document.getElementById("tipoProcesso").disabled = false;
              document.getElementById("statusFatura").disabled = false;
          }
          else
          {
              document.getElementById("periodoConsultado").disabled = true;
              document.getElementById("tipoProcesso").disabled = true;
              document.getElementById("statusFatura").disabled = true;
          }
      },
      nomeAluno(novo, antigo)
      {
          if(novo.length  > 0)
          {
              this.toggleNomeAluno = true;
              this.toggleCodigoBarra = false;
              this.codigoBarras = ''
          }else
          {
              this.toggleNomeAluno = false;
              this.toggleCodigoBarra = true;
          }
      },
      selected(novo, antigo)
  {
    // EXIBIR BOTÃO PARA GERAR FATURAS
    if(this.selected > '')
    {
      this.faturasSelecionadas = true;
    }
    else
    {
      this.faturasSelecionadas = false;
    }
  },
      selectAll(novo, antigo)
  {
    if(novo === true && antigo === false)
    {
      // this.selected = true;
      this.selected = [];
      for (let i in this.faturas)
      {
        if(this.faturas[i].link == '')
        {
          this.selected.push(
            this.faturas[i].id,
          );
        }
      }
      this.loadCheckBox = false;
    }
    if(antigo === true && novo === false)
    {
      // this.selected = false;
      this.loadCheckBox = false;
    }
  },
  },

}
</script>

<style lang="scss" scoped>
.status {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 0.5;

  .status-item {
      display: flex;
      align-items: center;
      gap: 0.5rem;
  }
}

.fatura-tabela {
  overflow-x: auto;

  table {
      min-width: 60rem;
  }
}

.modal-wrapper {
display: table-cell;
vertical-align: middle;
}

td {
  width: auto !important;
}

.espacamento-oculto {
  color: transparent;
  user-select: none;
}

.action-button {
  border: 0;
  background: transparent;
}

// ÍCONES DE AÇÕES
.fa
{
  color: #1c2d5a;
  font-size: auto;
  padding: 10px;
  border-radius: 50%;
  color: white;
}

.fa-file
{
  background-color: #20c997;
  border-color: #20c997;
  box-shadow: black;
}

.fa-eye:hover
{
  background-color: #20c9967e;
}

.fa-close
{
  background-color: #dc3545;
  border-color: #dc3545;
  box-shadow: black;
}

.fa-close:hover
{
  background-color: #dc354683;
}

.fa-refresh
{
  background-color: #76c5ea;
  border-color: #76c5ea;
  box-shadow: black;
}

.fa-percent
{
  background-color: rgb(241, 194, 50);
  border-color: rgb(241, 194, 50);
  box-shadow: black;
}

.fa-refresh:hover
{
  background-color: #76c5ea82;
}

// ÍCONES DE STATUS
.fa-circle.success
{
  color: #20c997;
}

.fa-circle.danger
{
  color: #dc3545;
}

.fa-circle.secondary
{
  color: #ced4da;
}

// ÁREAS DESABILITADAS
.disabled
{
  background-color: #e9ecef;
}

.no-user-select
{
  user-select: none;
}

// PERSONALIZAÇÕES DOS BOTÕES
.icon-branco
{
  color: white !important;
}

.font-button-modified
{
  font-size: 1em;
  font-weight: 700;
  letter-spacing: 5px;
}

input.form-control
{
  height: 36px;
  margin-top: -3.5px;
}

.btn.btn-success
{
  background-color: #20c997;
  color: white;
  box-shadow: none;
}

.btn.btn-success:hover
{
  background-color: #20c996c9;
}

/* Estilo iOS */

.switch
{
visibility: hidden;
position: absolute;
margin-left: -9999px;
}

.switch + label
{
display: inline-flex;
position: relative;
cursor: pointer;
outline: none;
user-select: none;
}

.switch--shadow + label
{
padding: 2px;
width: 60px;
height: 31px;
background-color: #dddddd;
border-radius: 30px;
margin: 0;
}

.switch--shadow + label:before,
.switch--shadow + label:after
{
display: block;
position: absolute;
top: 1px;
left: 1px;
bottom: 1px;
content: "";
}

.switch--shadow + label:before
{
right: 1px;
background-color: #f1f1f1;
border-radius: 30px;
transition: background 0.4s;
}

.switch--shadow + label:after
{
width: 28px;
background-color: #fff;
border-radius: 50%;
box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
transition: all 0.4s;
}

.switch--shadow:checked + label:before
{
background-color: #8ce196;
}

.switch--shadow:checked + label:after
{
transform: translateX(30px);
}

// ESTILIZAÇÃO PARA MODAL

.modal-mask {
position: fixed;
z-index: 9998;
top: 0;
left: 0;
width: 100%;
height: 100%;
background-color: rgba(0, 0, 0, 0.5);
display: table;
transition: opacity 0.3s ease;
}

.modal-wrapper {
display: table-cell;
vertical-align: middle;
}

.modal-container {
width: 350px;
margin: 0px auto;
padding: 20px 30px;
background-color: #fff;
border-radius: 20px;
box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
transition: all 0.3s ease;
font-family: Helvetica, Arial, sans-serif;
}
.modal-container-large {
width: 70%;
margin: 0px auto;
padding: 20px 30px;
background-color: #fff;
border-radius: 20px;
box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
transition: all 0.3s ease;
font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
margin-top: 0;
color: #34495e;
  text-align: center;
}

.modal-body {
margin: 10px 0;
}

.modal-default-button {
float: right;
}

/*
* The following styles are auto-applied to elements with
* transition="modal" when their visibility is toggled
* by Vue.js.
*
* You can easily play with the modal transition by editing
* these styles.
*/

.modal-enter {
opacity: 0;
}

.modal-leave-active {
opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
-webkit-transform: scale(1.1);
transform: scale(1.1);
}

</style>
